/*!
 *  (c)(r) 2008-2021 IT-Service Robert Frunzke
 */

import { mj } from './page-mj.js';

import { MCImage } from './media.image.js';
import { MCVideo } from './media.video.js';
import { MCAudio } from './media.audio.js';
import { MCText } from './media.text.js';
import { MCUnknown } from './media.unknown.js';
import { MCContainer } from './media.container.js';
import { MCOther } from './media.other.js';

export let MCFactories = function(mj) {
	return {
		init: function() {
			mj.mc_ns = {
				0: MCUnknown,
				1: MCImage,
				2: MCVideo,
				3: MCAudio,
				4: MCText,
				5: MCUnknown,	// MC_COMBINED - unused
				6: MCContainer,	// MC_CONTAINER
				7: MCOther,		// MC_OTHER
			};
			for( var mc=0; mc<8; ++mc ) {
				var mc_impl = mj.mc_ns[mc];
				mc_impl.init();
			}
		},
	};
}(mj);
